module.exports = Object.assign(require('./Manufacturing-Import.json'), {
  visibility: false,
  locked: false,
  deletable: true,
  defaultItems: {},
  orderStatuses: require('../OrderStatuses.js'),
  tabs: [
    require('./Tab0-MasterData.js'),
    require('./Tab1-STL.js'),
    require('./Tab4-Cart.js'),
  ],
  productTree: require('../ProductTree.json'),
});
